import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import MediaDisplay from "@/components/drops/view/item/content/media/MediaDisplay";
import type { ResolvedPreviewHref } from "./MarketplaceItemPreviewCard.types";
import { MARKETPLACE_MEDIA_FRAME_CLASS } from "./previewLayout";
interface MarketplaceItemPreviewMediaLinkProps {
  readonly mediaUrl: string;
  readonly mediaMimeType: string;
  readonly resolvedPreviewHref: ResolvedPreviewHref;
}
export default function MarketplaceItemPreviewMediaLink(t0) {
  const $ = _c(8);
  const {
    mediaUrl,
    mediaMimeType,
    resolvedPreviewHref
  } = t0;
  const {
    href,
    target,
    rel
  } = resolvedPreviewHref;
  let t1;
  if ($[0] !== mediaMimeType || $[1] !== mediaUrl) {
    t1 = <div className={`${MARKETPLACE_MEDIA_FRAME_CLASS} tw-relative`} data-testid="manifold-item-media"><MediaDisplay media_mime_type={mediaMimeType} media_url={mediaUrl} disableMediaInteraction={true} /></div>;
    $[0] = mediaMimeType;
    $[1] = mediaUrl;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== href || $[4] !== rel || $[5] !== t1 || $[6] !== target) {
    t2 = <Link href={href} target={target} rel={rel} prefetch={false} className="tw-flex tw-w-full tw-flex-col tw-overflow-hidden tw-no-underline" data-testid="marketplace-item-media-link">{t1}</Link>;
    $[3] = href;
    $[4] = rel;
    $[5] = t1;
    $[6] = target;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}